/* SEKO : message affiche quand la cliente choisit une pointure qui n'est plus disponible.
   Exception : si la pointure est encore en rayon (window.SEKO_DISPO = 2), pas de message "Oups" :
   la mention "Disponible uniquement en boutique" suffit. */
(function () {
  var titre = document.querySelector('[data-seko-produit]');
  if (!titre) return;
  var handle = titre.getAttribute('data-seko-produit');
  var collection = titre.getAttribute('data-seko-collection') || '/collections/all';
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var variantes = null;

  fetch(base + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) { variantes = (p && p.variants) || []; })
    .catch(function () {});

  /* Le texte affiche sur une case (ex. "44"), et non sa valeur technique, qui est un identifiant */
  function etiquette(input) {
    var l = null;
    if (input.id) {
      try { l = document.querySelector('label[for="' + input.id.replace(/"/g, '') + '"]'); } catch (e) {}
    }
    if (!l) { l = input.closest('label') || input.nextElementSibling; }
    return l ? (l.textContent || '').trim() : '';
  }

  function varianteChoisie() {
    if (!variantes) return null;
    /* 1. Le plus fiable : l'identifiant de variante que le theme inscrit dans le formulaire */
    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (champ && champ.value) {
      for (var a = 0; a < variantes.length; a++) {
        if (String(variantes[a].id) === String(champ.value)) return variantes[a];
      }
    }
    /* 2. A defaut : on compare les textes des cases cochees aux options des variantes */
    var coches = document.querySelectorAll('.variant-picker input[type="radio"]:checked');
    if (!coches.length) return null;
    var valeurs = [];
    for (var i = 0; i < coches.length; i++) { valeurs.push(etiquette(coches[i])); }
    for (var j = 0; j < variantes.length; j++) {
      var opts = variantes[j].options || [];
      var ok = true;
      for (var k = 0; k < valeurs.length; k++) { if (opts.indexOf(valeurs[k]) === -1) { ok = false; } }
      if (ok) return variantes[j];
    }
    return null;
  }

  function styles() {
    if (document.getElementById('seko-oups-css')) return;
    var s = document.createElement('style');
    s.id = 'seko-oups-css';
    s.textContent = '.seko-oups{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:flex-end;justify-content:center;background:rgba(37,37,36,.55);padding:0;opacity:0;transition:opacity .2s ease}' +
      '.seko-oups.est-ouvert{opacity:1}' +
      '.seko-oups__carte{position:relative;width:100%;max-width:440px;background:#FBFAF8;color:#252524;border-radius:10px 10px 0 0;padding:26px 22px calc(22px + env(safe-area-inset-bottom,0px));text-align:left;transform:translateY(16px);transition:transform .22s ease}' +
      '.seko-oups.est-ouvert .seko-oups__carte{transform:none}' +
      '.seko-oups__fermer{position:absolute;top:12px;right:12px;width:36px;height:36px;border-radius:50%;border:0;background:#252524;color:#FFFFFF;font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;font-family:inherit}' +
      '.seko-oups__label{font-size:11px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#8A8378;margin:0 48px 8px 0}' +
      '.seko-oups__titre{font-size:20px;line-height:1.25;font-weight:600;margin:0 40px 10px 0;letter-spacing:0;text-transform:none}' +
      '.seko-oups__texte{font-size:14.5px;line-height:1.6;color:#4A4744;margin:0 0 10px}' +
      '.seko-oups__btn{display:flex;align-items:center;justify-content:center;min-height:50px;margin-top:18px;border-radius:4px;border:1px solid #252524;background:#252524;color:#FFFFFF;font-size:15px;font-weight:600;cursor:pointer;text-decoration:none;padding:0 14px;font-family:inherit}' +
      '@media (min-width:700px){.seko-oups{align-items:center;padding:20px}.seko-oups__carte{border-radius:10px}}';
    document.head.appendChild(s);
  }

  function fermer() {
    var m = document.querySelector('.seko-oups');
    if (!m) return;
    m.classList.remove('est-ouvert');
    setTimeout(function () { if (m.parentNode) { m.parentNode.removeChild(m); } }, 220);
    document.removeEventListener('keydown', surTouche);
  }

  function surTouche(e) { if (e.key === 'Escape') { fermer(); } }

  function ouvrir(pointure) {
    if (document.querySelector('.seko-oups')) return;
    styles();
    var nom = (titre.textContent || '').trim();
    var m = document.createElement('div');
    m.className = 'seko-oups';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Pointure indisponible');

    var carte = document.createElement('div');
    carte.className = 'seko-oups__carte';

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'seko-oups__fermer';
    x.setAttribute('aria-label', 'Fermer');
    x.textContent = '×';
    x.addEventListener('click', fermer);

    var label = document.createElement('p');
    label.className = 'seko-oups__label';
    label.textContent = nom + (pointure ? ' · pointure ' + pointure : '');

    var h = document.createElement('h2');
    h.className = 'seko-oups__titre';
    h.textContent = 'Oups, cette pointure a déjà trouvé preneur';

    var p1 = document.createElement('p');
    p1.className = 'seko-oups__texte';
    p1.textContent = 'Elle n’est plus disponible pour ce modèle. Notre site est tenu à jour : notre service client a bien des talents, mais pas encore celui de faire apparaître une paire par magie.';

    var p2 = document.createElement('p');
    p2.className = 'seko-oups__texte';
    p2.textContent = 'La bonne nouvelle : d’autres modèles vous attendent.';

    var a = document.createElement('a');
    a.className = 'seko-oups__btn';
    a.href = collection;
    a.textContent = 'Voir les autres modèles';

    carte.appendChild(x);
    carte.appendChild(label);
    carte.appendChild(h);
    carte.appendChild(p1);
    carte.appendChild(p2);
    carte.appendChild(a);
    m.appendChild(carte);
    m.addEventListener('click', function (e) { if (e.target === m) { fermer(); } });
    document.body.appendChild(m);
    document.addEventListener('keydown', surTouche);
    requestAnimationFrame(function () { m.classList.add('est-ouvert'); a.focus(); });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.variant-picker input[type="radio"]')) return;
    var texte = etiquette(t);
    setTimeout(function () {
      var v = varianteChoisie();
      var enRayon = v && window.SEKO_DISPO && window.SEKO_DISPO[String(v.id)] === 2;
      if (v && v.available === false && !enRayon) { ouvrir(texte); }
    }, 180);
  }, true);
})();
